module.exports = __webpack_public_path__ + "img/documentsactive.5d4aef75.svg";